import { countries } from "@/data/countries";

// Countries without official Unicode emoji flag support
// These use user-assigned or exceptional reservation codes
const NO_EMOJI_FLAG_COUNTRIES = new Set(['XK']); // Kosovo

/**
 * Convert ISO Alpha-2 country code to emoji flag
 * @param countryCode - ISO Alpha-2 country code (e.g., "US", "GB")
 * @returns Emoji flag string, or empty string for unsupported countries
 */
export function getCountryFlag(countryCode: string): string {
  if (!countryCode || countryCode.length !== 2) return "";
  
  const upperCode = countryCode.toUpperCase();
  
  // Return empty for countries without Unicode flag support
  if (NO_EMOJI_FLAG_COUNTRIES.has(upperCode)) {
    return "";
  }
  
  const codePoints = upperCode
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  
  return String.fromCodePoint(...codePoints);
}

/**
 * Get country name from ISO Alpha-2 code
 * @param countryCode - ISO Alpha-2 country code (e.g., "US", "GB")
 * @returns Country name or null if not found
 */
export function getCountryName(countryCode: string | null): string | null {
  if (!countryCode) return null;
  const country = countries.find(c => c.code.toUpperCase() === countryCode.toUpperCase());
  return country?.name ?? null;
}
